import i18n from '@/i18n';
import { roles } from '@/utils/permission';
import { PREFIX } from '@/utils/constants';
const Layout = () => import('@/layouts/main.vue');
const Roles = () => import('./views/Index.vue');
const RoleView = () => import('./views/RoleView.vue');

export default [
  {
    path: 'roles',
    component: Layout,
    meta: { authRequired: true, header: true },
    children: [
      {
        path: '',
        name: `${PREFIX.INSPECTOR}.Roles`,
        component: Roles,
        meta: { title: i18n.global.t('roles.roles'), permission: { module: roles.module, key: roles.showAll } },
      },
      {
        path: 'view/:id?',
        name: `${PREFIX.INSPECTOR}.Roles.View`,
        component: RoleView,
        meta: {
          title: i18n.global.t('roles.view'),
          pageType: 'view',
          permission: { module: roles.module, key: roles.showOne },
        },
        props: true,
      },
      {
        path: 'create',
        name: `${PREFIX.INSPECTOR}.Roles.Create`,
        component: RoleView,
        meta: {
          title: i18n.global.t('roles.create'),
          pageType: 'create',
          permission: { module: roles.module, key: roles.create },
        },
      },
      {
        path: 'update/:id?',
        name: `${PREFIX.INSPECTOR}.Roles.Update`,
        meta: {
          title: i18n.global.t('roles.update'),
          pageType: 'update',
          permission: { module: roles.module, key: roles.update },
        },
        component: RoleView,
        props: true,
      },
    ],
  },
];
